import React from "react";
import {Container,Row,Col} from "react-bootstrap";
import Resources from "../../../Resources/Resources";
import PageFooter from "../../../components/PageFooter";
import '../../../myga.css';
import {isValid, mygaSession} from "../../../scripts/myga-session";
import {NassauLog} from "../../../scripts/myga-utils"
import {PageManager} from "../../../scripts/page-manager";
import {PAGES, PARTY, STORAGE_KEYS} from "../../../scripts/constants";
import {saveValidationReport} from "../../../scripts/sync-manager";
import GENERATOR from "../../../selenium-front-end/generator/Generator";
import {getInfoForZip} from "../../../scripts/zip-helper";

class AppContentWrapper extends React.Component {
  
  constructor(props) {
    super(props);
    
    // this.prevLabel = this.props.prevLabel || Resources.Strings.General_ButtonBackLabel;
    // this.nextLabel = mygaSession.getReturnToPage()!==null ? "Back" : this.props.nextLabel || Resources.Strings.General_ButtonForwardLabel;
    this.state = {
      backBusy: false,
      nextBusy: false
    }
  
    // 2022.07.05.ADivelbiss - Added to record the current error message for testing
    this.updateErrorMessage();
    // NassauLog(`AppContentWrapper: this.state.nextPage=${this.state.nextPage}`)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    // 2022.07.05.ADivelbiss - Added to record the current error message for testing
    this.updateErrorMessage();
    
    // if (this.props.nextPage && prevProps.nextPage !== this.props.nextPage) {
    //   this.setState({
    //     nextPage: this.props.nextPage
    //   }, ()=>{
    //     NassauLog(`AppContentWrapper: this.state.nextPage=${this.state.nextPage}`)
    //   })
    // }
  }

  /**
   * Navigate to the previous page.
   */
  navigateBack(prevPage) {
    if (prevPage) {
      this.props.updatePage(prevPage);
    }
  }
  
  /**
   * Navigate to the next page
   */
  navigateNext(nextPage) {

    // 2021.08.10.ADivelbiss - handling in the PageManager now
    // // clear the mygasession prevpage
    // if (mygaSession.getReturnToPage()!==null) {
    //   mygaSession.clearReturnToPage();
    // }
  
    // move to the next page
    if (nextPage) {
      this.props.updatePage(nextPage);
    }
    
  }
  
  onBackPressed = async () => {
    if (this.props.onBackPressed) {
      await this.props.onBackPressed();

      if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
        const page = PageManager.getCurrentPage()
        NassauLog(`GENERATOR committing ${page}`)
        await GENERATOR.commitStagedActionList(page)
        await GENERATOR.handlePrevBtnEvent(page)
      }
    }
  };
  
  /**
   * Perform any application updates to the local app
   * then return which application section to update.
   * subclasses should override if application data is to be saved
   * @returns {null}
   */
  onNextPressed = async () =>  {
    if (this.props.onNextPressed) {
      await this.props.onNextPressed();

      if (process.env.REACT_APP_TESTING === '1' && GENERATOR.getTestModeEnabled()) {
        const page = PageManager.getCurrentPage()
        NassauLog(`committing ${page}`)
        await GENERATOR.commitStagedActionList(page)
        await GENERATOR.handleNextBtnEvent(page)
      }
    }
  };
  
  /**
   * Dedicated method to update the previous page.
   * The motivation for this is to permit dynamic changes in the previous page flow
   * while still on the current page.
   */
  updatePrevPage = () => {
  
    // validity check
    if (this.props.validateOnPrev && !this.props.validateOnPrev()) {
      return;
    }

    // display the activity indicator
    this.setState({backBusy:true});
    
    // get the previous page before we pop the current
    let prevPage = PageManager.getPreviousPage();
  
    // pop the current page
    PageManager.popCurrentPage();
  
    this.onBackPressed()
        .then((data) => {
          // NassauLog('AppContentWrapper - onBackPressed - data: ' + JSON.stringify(data));
        
          // Clear activity indicator
          this.setState({backBusy:false});
  
          // move to the next page.
          this.navigateBack(prevPage);
          
        })
        .catch((err) => {
          NassauLog(err);
          
          // TODO: Handle app data save error. Message popup? retry?
          this.setState({backBusy:false});
        
          // TODO: TEMPORARILY MOVE TO NEXT PAGE
          this.navigateBack(prevPage);
        });
  }
  
  /**
   * Dedicated method to update the next page.
   * The motivation for this is to permit dynamic changes in the next page flow
   * while still on the current page.
   */
  updateNextPage = async () => {
  
    // validity check
    if (this.props.validateOnNext && !(await this.props.validateOnNext())) {
      return;
    }
  
    // start activity indicator
    this.setState({nextBusy:true});
    
    //  save the current application data and
    this.onNextPressed()
        .then(()=>{
          return saveValidationReport();
        })
        .then((/*nextPageOrNull*/) => {
        
          // 2021.07.16.ADivelbiss - This whole section is no longer needed to specify the next page
          // instead we will use the new PageManager, which will determine the next page based on
          // the saved application state.  nextPageOrNull is expected to always be null this date
          // forward.
  
          // Clear activity indicator
          this.setState({nextBusy:false});
  
          // move to the next page.
          this.navigateNext(PageManager.getNextPage());
          
          
          // 2021.05.11.ADivelbiss - Since we were not really using the data at this point for anything except debugging
          // and since we needed a way to choose a different next page at this point
          // this method is now assuming that data is either null, or an alternate "nextPage".
          // The motivation is that we needed a way to validate an agent code just after the user registers an
          // email so that the agent screen can be skipped completely if the agent code is valid, or can be shown
          // if it was invalid or not provided.
          //
          // Originally this was used simply to record the result of a startApplication or saveApplication
          // operation in the console logs.
          // NassauLog('AppContentWrapper - onNextPressed - data: ' + JSON.stringify(data));
        
          // Check to see if we have an alternate next page
          // if (isValid(nextPageOrNull)) {
          //   NassauLog('AppContentWrapper - onNextPressed - nextPageOrNull: ' + nextPageOrNull);
          //   this.setState({
          //     nextPage: nextPageOrNull
          //   })
          // }
          //
          // // Clear activity indicator
          // this.setState({nextBusy:false});
          //
          // // move to the next page.
          // this.navigateNext(page);
        })
        .catch((err) => {
          NassauLog(err.message);
          // TODO: Handle app data save error. Message popup? retry?
          this.setState({nextBusy:false});
        
          // TODO: TEMPORARILY MOVE TO NEXT PAGE
          this.navigateNext(PageManager.getNextPage());
        });
    
  }
  
  // 2022.07.05.ADivelbiss - Added to record the current error message for testing
  updateErrorMessage = () => {
    if (this.props.errorMessage && this.props.errorMessage.length>0) {
      mygaSession.setErrorMessage(this.props.errorMessage);
    } else {
      mygaSession.setErrorMessage('');
    }
  }
  
  render() {

    let centeredStyle = (this.props.centerChildren) ? {justifyContent: 'center'} : {};
    let paddingStyle = (this.props.noXPadding) ? {paddingLeft: '0', paddingRight: '0'} : {};
    let containerStyles = Object.assign({}, centeredStyle, paddingStyle);
    //const appStateAbbr = mygaSession.getMygaSessionValue(STORAGE_KEYS.AppStateAbbr);

    // get the current prev and next pages
    const pPage = PageManager.getPreviousPage();
    const nPage = PageManager.getNextPage();
    
    // Decide what label to use for the next button.
    const pLabel = isValid(this.props.prevLabel) ? this.props.prevLabel : Resources.Strings.General_ButtonBackLabel;
    const nLabel = isValid(this.props.nextLabel) ?  this.props.nextLabel :  isValid(pPage) ? Resources.Strings.General_ButtonForwardLabel : Resources.Strings.General_ButtonOKLabel;
    
    return (
        
        <Container className={"page-area"}>
          
          <Row className={'page-content-area'}>
            <Col className={"page-container"} style={containerStyles}>
  
              <div style={{marginBottom:'0.5em'}}>
                {this.props.children}
              </div>
              
            </Col>
          </Row>
  
          <Row className={'text-center'}>
            <Col sm={3} className="hidden-xs"/>
            <Col xs={12} sm={6} >
                {
                  this.props.errorMessage && this.props.errorMessage.length>0 && (
                      <div className="validation-error" style={{textAlign: "center"}}>
                        {this.props.errorMessage}
                      </div>
                  )
                }
            </Col>
          </Row>
  
          <PageFooter prevPage={pPage}
                      prevLabel={pLabel}
                      prevBusy={this.state.backBusy}
                      updatePrevPage={this.updatePrevPage}
                      nextPage={nPage}
                      nextLabel={nLabel}
                      nextBusy={this.state.nextBusy}
                      updateNextPage={this.updateNextPage}/>
          
          {/*{*/}
          {/*  mygaSession.getReturnToPage()!==null ? (*/}
          {/*      <PageFooter nextPage={mygaSession.getReturnToPage()}*/}
          {/*                  nextLabel={this.nextLabel}*/}
          {/*                  nextBusy={this.state.nextBusy}*/}
          {/*                  updateNextPage={this.updateNextPage}/>*/}
          {/*  ) : (*/}
          {/*      <PageFooter prevPage={PageManager.getPreviousPage()}*/}
          {/*                  prevLabel={this.prevLabel}*/}
          {/*                  prevBusy={this.state.backBusy}*/}
          {/*                  updatePrevPage={this.updatePrevPage}*/}
          {/*                  nextPage={PageManager.getNextPage()}*/}
          {/*                  nextLabel={this.nextLabel}*/}
          {/*                  nextBusy={this.state.nextBusy}*/}
          {/*                  updateNextPage={this.updateNextPage}/>*/}
          {/*  )*/}
          {/*}*/}
        
        
        </Container>
    
    );
    
  }
}

export default AppContentWrapper;